let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fMrUo"), load("4Wdqb"), load("bJykp"), load("6xeV7")]).then(() => parcelRequire('lX1JT'));